export default "__VITE_ASSET__Bp64PnqH__"